import StyledNewlySharedInfo from './StyledNewlySharedInfo';
import MobileRowPicker from './MobileRowPicker';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';
import { PersonAddOutlined as NewlySharedIcon } from '@mui/icons-material';
import isTouchDevice from '@/lib/utils/isTouchDevice';

const NewlySharedInfo = () => (
  <StyledNewlySharedInfo>
    <section>
      <NewlySharedIcon />
      <FormattedMessageWithChallengeNaming
        id={`portfolio.challenge.newly_shared_info${isTouchDevice() ? '.mobile' : ''}`}
      />
    </section>
    <MobileRowPicker />
  </StyledNewlySharedInfo>
);

export default NewlySharedInfo;
